import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { GtmService } from './gtm.service';

export function gtmInitializerFn(): void | Observable<unknown> | Promise<unknown> {
    const gtm = inject(GtmService);
    return gtm.init();
}
